<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-7">
          <h1>Payment History</h1>
        </div>
      </div>
    </section>
    <section class="content">
      <form v-on:submit.prevent="searchReportData">
        <div class="row">
          <div class="col-sm-2 col-xs-6">
            <div class="form-group">
              <filterDropdownOptions />
            </div>
          </div>
          <div class="col-sm-3 col-xs-6 form-group">
            <input
              placeholder="From"
              type="text"
              value=""
              name="starttime"
              id="starttime"
              v-model="starttime"
              class="form-control input-sm datePicker"
              required=""
            />
          </div>
          <div class="col-sm-3 col-xs-6 form-group">
            <input
              placeholder="To"
              type="text"
              value=""
              name="stoptime"
              id="stoptime"
              v-model="stoptime"
              class="form-control input-sm datePicker"
              required=""
            />
          </div>
          <div class="col-xs-6 col-sm-2 form-group">
            <select
              title=""
              name="type"
              id="type"
              class="form-control input-sm select2"
              v-select="type"
              v-model="type"
              @change="searchReportData"
            >
              <option value="">Filter Type</option>
              <option value="1">Paid</option>
              <option value="3">Return</option>
            </select>
          </div>
          <div
            class="col-sm-2 col-xs-6 form-group btnLeft"
            style="margin-bottom: 0"
          >
            <button type="submit" class="btn btn-sm btn-submit">
              <i class="fa fa-search"></i> Search
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12">
          <div class="box" id="pagination">
            <div class="box-header">
              <h3 class="box-title">Total {{ listArr.length }} Row Found</h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <div class="table-responsive">
                  <table class="table table-0024 table-bordered table-striped">
                    <thead>
                      <tr>
                        <th class="tdCenter tdSN">SN</th>
                        <th class="tdCenter">Payment date</th>
                        <th class="tdCenter" width="300">Description</th>
                        <th class="tdCenter">Last Balance</th>
                        <th class="tdCenter">Payment Type</th>
                        <th class="tdCenter">No Of PIN</th>
                        <th class="tdCenter">Recharged</th>
                        <th class="tdCenter">Cash Amount</th>
                        <th class="tdCenter">Row Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in listArr" :key="data.id">
                        <td class="tdCenter tdSN">
                          {{ parseInt(++index) }}
                        </td>
                        <td class="tdCenter">
                          {{ data.creationdate }}
                        </td>
                        <td class="tdCenter">
                          {{ data.description }}
                        </td>
                        <td class="tdCenter">
                          {{ parseFloat(data.lastbalance).toFixed(2) }}
                        </td>
                        <td
                          :class="
                            data.type == 3 ? 'tdCenter text-red' : 'tdCenter'
                          "
                        >
                          <span v-if="data.type == 3"> Returned </span>
                          <span v-else> Pre-Paid </span>
                        </td>
                        <td
                          :class="
                            data.type == 3 ? 'tdCenter text-red' : 'tdCenter'
                          "
                        >
                          <span
                            v-if="data.recharged_balance > 0 && data.type == 3"
                          >
                            <strong> - </strong>
                          </span>
                          <span v-if="data.no_of_pins > 0">
                            {{ data.no_of_pins }}
                          </span>
                          <span v-else> - </span>
                        </td>
                        <td
                          :class="
                            data.type == 3 ? 'tdRight text-red' : 'tdRight'
                          "
                        >
                          <span
                            v-if="data.recharged_balance > 0 && data.type == 3"
                          >
                            <strong> - </strong>
                          </span>
                          <span v-if="data.recharged_balance > 0">
                            {{ data.recharged_balance }}
                          </span>
                          <span v-else> - </span>
                        </td>
                        <td
                          :class="
                            data.type == 3
                              ? 'info tdRight text-red'
                              : 'info tdRight'
                          "
                        >
                          <span
                            v-if="data.recharged_balance > 0 && data.type == 3"
                          >
                            <strong> - </strong>
                          </span>
                          {{ parseFloat(data.amount).toFixed(2) }}
                        </td>
                        <td class="success tdRight">
                          {{ parseFloat(data.line_total_amount).toFixed(2) }}
                        </td>
                      </tr>
                      <tr v-if="listArr.length == 0">
                        <td
                          colspan="15"
                          class="tdCenter"
                          style="padding: 30px 0"
                        >
                          <b>No Records Found</b>
                        </td>
                      </tr>
                      <tr>
                        <th colspan="7" class="tdRight">
                          <strong>Total :</strong>
                        </th>
                        <th class="tdRight">
                          <strong>
                            {{
                              parseFloat(line_total_amount).toFixed(2)
                            }}</strong
                          >
                        </th>
                        <th class="tdRight">
                          <strong>
                            {{
                              parseFloat(line_total_amount).toFixed(2)
                            }}</strong
                          >
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-middle-small table-bordered">
                <thead>
                  <tr>
                    <th
                      class="tdCenter"
                      style="text-align: center; font-size: 14px"
                      rowspan="2"
                    >
                      Total
                    </th>
                    <th class="tdCenter">Transaction</th>
                    <th class="tdCenter">Cash Payment</th>
                    <th class="tdCenter">Returned Amount</th>
                    <th class="tdCenter">Amount</th>
                  </tr>
                  <tr>
                    <th class="tdRight">{{ listArr.length }}</th>
                    <th class="success tdRight">
                      {{ recharged_amount }}
                    </th>
                    <th class="warning tdRight">
                      {{ return_amount }}
                    </th>
                    <th class="info tdRight">
                      {{ parseFloat(line_total_amount).toFixed(2) }}
                    </th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
import axios from "axios";
export default {
  name: "PaymentReport",
  components: {
    filterDropdownOptions,
  },
  data() {
    return {
      listArr: {},
      lineTotalAmount: 0,
      type: "",
      id_reseller: "",
      starttime: "",
      stoptime: "",
      line_total_amount: 0,
      recharged_amount: 0,
      return_amount: 0,
    };
  },
  created() {
    this.com_user_type_access([0, 1, 5, 6, 7], true);
    this.filterWiseDateRangeSet();
    this.searchReportData();
  },
  methods: {
    searchReportData() {
      loader.show();
      var rootObject = this;

      const form = new FormData();
      form.append("type", this.type);
      form.append("fromDate", this.starttime);
      form.append("toDate", this.stoptime);
      form.append("short_filter", $("#short_filter").val());

      var config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      axios
        .post("reports/payment-report", form, config)
        .then(function (response) {
          rootObject.populateReportData(response);
        })
        .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          console.log(alertmessage);
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    populateReportData(response) {
      var line_total_amount = 0;
      var recharged_amount = 0;
      var return_amount = 0;
      this.listArr = [];
      this.line_total_amount = 0;
      this.recharged_amount = 0;
      this.return_amount = 0;

      for (var prop in response.data.data) {
        if (response.data.data[prop]["type"] == 3) {
          line_total_amount =
            parseFloat(line_total_amount) -
            parseFloat(response.data.data[prop]["amount"]);
          response.data.data[prop][
            "line_total_amount"
          ] = line_total_amount.toFixed(2);
          return_amount =
            parseFloat(return_amount) +
            parseFloat(response.data.data[prop]["amount"]);
          this.listArr.push(response.data.data[prop]);
        } else {
          line_total_amount =
            parseFloat(line_total_amount) +
            parseFloat(response.data.data[prop]["amount"]);
          response.data.data[prop][
            "line_total_amount"
          ] = line_total_amount.toFixed(2);
          recharged_amount =
            parseFloat(recharged_amount) +
            parseFloat(response.data.data[prop]["amount"]);
          this.listArr.push(response.data.data[prop]);
        }
      }

      this.line_total_amount = line_total_amount.toFixed(2);
      this.return_amount = return_amount.toFixed(2);
      this.recharged_amount = recharged_amount.toFixed(2);
      loader.hide();
    },

    filterWiseDateRangeSet() {
      $(".datePicker").removeAttr("readonly", "readonly");
      if ($("#short_filter").val()) {
        this.starttime = "";
        this.stoptime = "";
        $(".datePicker").attr("readonly", "readonly");
      } else {
        var dateRangeArr = this.com_currentDateRange(-90);
        this.starttime = dateRangeArr.startDate;
        this.stoptime = dateRangeArr.endDate;
      }
    },
  },
  mounted: function () {
    var rootObject = this;

    $("#starttime")
      .datetimepicker({
        timepicker: false,
        format: "Y-m-d",
      })
      .on("change", function (e) {
        rootObject.starttime = $(this).val();
      });

    $("#stoptime")
      .datetimepicker({
        timepicker: false,
        format: "Y-m-d",
      })
      .on("change", function (e) {
        rootObject.stoptime = $(this).val();
      });

    $("#short_filter").on("change", function () {
      rootObject.filterWiseDateRangeSet();
      rootObject.searchReportData();
    });

    $(".select2").select2();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
